import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MainPageBlockWithResizes } from '../../interfaces/main-page-block';

@Component({
  selector: 'app-html-block',
  templateUrl: './html-block.component.html',
  styleUrls: ['./html-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HtmlBlockComponent {
  @Input() block?: MainPageBlockWithResizes;
}
